export abstract class ChatEngineSendMessageService {
  public abstract sendTextMessage(channelUniqueName: string, message: string): Promise<void>;
}
